import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHomeContent: builder.query<any, void>({
      query: () => {
        return {
          url: `api/homepage`,
        };
      },
    }),
  }),
});


export { injectedRtkApi as enhancedApi };



export const {useGetHomeContentQuery } = injectedRtkApi;